export const environment = {
  production: true,
  serverUrl: "https://dev-monitoreo.coviar.com.ar:9443"
};
